/**
 * MP carousels — pin to the first card until the user interacts, y evitar que
 * un arrastre acabe navegando (tarjetas clickeables completas).
 *
 * Used by MP Brand Ambassadors (v1 + v2) and MP Image + Text Carousel; any other
 * section built on the theme's slideshow-component can opt in by adding its
 * slideshow class to SELECTOR and loading this script.
 *
 * The scroller uses `scroll-snap-type: x mandatory`, and its slides carry the
 * theme's `content-visibility: auto`, so off-screen cards materialise late and
 * the scrollable width grows after load (e.g. 532px -> 3546px with 13 cards).
 * Safari/WebKit re-snaps a mandatory scroller whenever its content size changes,
 * which parked the carousel on a middle card (4th, 5th, even 9th) on mobile.
 *
 * There is no CSS-only cure: reserving the slide size shrinks the jump but does
 * not remove it. So we re-assert the start position while the layout settles,
 * and stop the moment the visitor actually touches the carousel.
 */

(function () {
  var SELECTOR = '.mp-ambv2__slideshow, .mp-ambassadors__slideshow, .mp-itc__slideshow';

  /* How long to keep correcting after load. Slides keep materialising while the
     section is still off-screen, so this outlives a simple 'load' listener. */
  var SETTLE_MS = 4000;

  function pin(slideshow) {
    var scroller = slideshow.querySelector('slideshow-slides');
    if (!scroller || scroller.dataset.mpPinned === 'true') return;
    scroller.dataset.mpPinned = 'true';

    var released = false;

    function release() {
      if (released) return;
      released = true;
      if (resizeObserver) resizeObserver.disconnect();
      clearInterval(interval);
      clearTimeout(settleTimer);
    }

    /* Any real intent to move the carousel wins over the correction. */
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (type) {
      scroller.addEventListener(type, release, { passive: true, once: true });
    });
    slideshow.addEventListener('click', function (e) {
      if (e.target.closest('.slideshow-control')) release();
    });

    function reset() {
      if (released || scroller.scrollLeft === 0) return;
      /* base.css sets `scroll-behavior: smooth` on the scroller, which would
         animate this correction — and animate it visibly. Jump instead. */
      scroller.scrollTo({ left: 0, behavior: 'instant' });
    }

    /* Correct on every layout change of the scroller or its content. */
    var resizeObserver = null;
    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(reset);
      resizeObserver.observe(scroller);
      var firstSlide = scroller.querySelector('slideshow-slide');
      if (firstSlide) resizeObserver.observe(firstSlide);
    }

    /* ResizeObserver misses the case where slides materialise without changing
       the scroller's own box, so poll cheaply while things settle. */
    var interval = setInterval(reset, 150);
    var settleTimer = setTimeout(release, SETTLE_MS);

    reset();
  }

  /**
   * Drag vs click.
   *
   * Con la tarjeta entera envuelta en un <a> (MP Brand Ambassadors V2), arrastrar
   * el carrusel con el mouse acababa navegando: assets/slideshow.js sí registra un
   * `click` -> preventDefault de un solo uso al empezar a arrastrar, pero lo quita
   * con `controller.abort()` dentro de `onPointerUp`, es decir ANTES de que el
   * click se dispare. Cuando el arrastre empieza y termina sobre la misma tarjeta,
   * el click llega vivo al enlace.
   *
   * Aquí se mide cuánto se movió el puntero entre `pointerdown` y `click`: si pasa
   * el umbral, fue un arrastre y el enlace no navega. Solo aplica a enlaces dentro
   * del scroller, así que las flechas (que viven fuera) no se ven afectadas, y los
   * clicks de teclado (`detail === 0`) pasan siempre.
   */
  var DRAG_SLOP = 8;

  function guardDragClicks(slideshow) {
    var scroller = slideshow.querySelector('slideshow-slides');
    if (!scroller || scroller.dataset.mpDragGuard === 'true') return;
    scroller.dataset.mpDragGuard = 'true';

    var startX = 0;
    var startY = 0;
    var hasStart = false;

    scroller.addEventListener(
      'pointerdown',
      function (e) {
        startX = e.clientX;
        startY = e.clientY;
        hasStart = true;
      },
      { capture: true, passive: true }
    );

    scroller.addEventListener(
      'click',
      function (e) {
        if (!hasStart || e.detail === 0) return;
        if (!e.target.closest || !e.target.closest('a[href]')) return;

        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        if (Math.sqrt(dx * dx + dy * dy) <= DRAG_SLOP) return;

        e.preventDefault();
        e.stopPropagation();
      },
      true
    );
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(function (slideshow) {
      pin(slideshow);
      guardDragClicks(slideshow);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor re-renders the section without a page load. */
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target || !e.target.querySelector) return;
    e.target.querySelectorAll(SELECTOR).forEach(function (slideshow) {
      pin(slideshow);
      guardDragClicks(slideshow);
    });
  });
})();
